module.exports = __webpack_public_path__ + "img/canada-diabetes-mellitus-male.bc82300b.png";